import React, { useState, useEffect, PropsWithChildren } from 'react';

import { IAnimated } from './interface';

const Animated: React.FC<IAnimated> = (props) => {
  const {
    show,
    animationIn,
    animationOut,
    animationInDelay,
    animationOutDelay,
    className,
    style,
    children,
  } = props;
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) setShouldRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setShouldRender(false);
  };

  const animation = show ? animationIn : animationOut;
  const animationDelay = show ? animationInDelay : animationOutDelay;

  return shouldRender ? (
    <div
      className={`animated ${animation} ${animationDelay} ${className || ''}`}
      onAnimationEnd={onAnimationEnd}
      style={style || {}}
    >
      {children}
    </div>
  ) : null;
};

export default Animated;
